import axios from "./axios"; // importing axios from customAxios

export function signUp(request) {
  return axios.post("/authenticate/auth/signup", request);
}

export function verifySignUp(request) {
  return axios.post("/authenticate/auth/signup/verify", request);
}

export function forgotPassword(request) {
  return axios.post("/authenticate/auth/forgotpassword", request);
}

export function login(request) {
  return axios.post("/authenticate/auth/login", request);
}

export function uploadDoc(formData) {
  return axios.post("/users/upload/file", formData);
}

export function uploadDocURL(request) {
  return axios.patch("/users/account", request);
}

export function updateUser(request) {
  return axios.post("/users/account", request);
}

export function contact(request) {
  return axios.post("/users/contact", request);
}

export function logOut() {
  return axios.post("/test/logOut");
}
